import type { ReactNode } from "react";

const IconFrame = ({ children }: { children: ReactNode }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const TreatmentPlanIcon = () => (
  <IconFrame>
    <path d="M7 3h7l5 5v13H7z" />
    <path d="M14 3v5h5" />
    <path d="M10 13h6M10 17h4" />
  </IconFrame>
);

export const WeeklyProgressIcon = () => (
  <IconFrame>
    <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
  </IconFrame>
);

export const HomeActivitiesIcon = () => (
  <IconFrame>
    <path d="M3 11l9-7 9 7" />
    <path d="M5 10v10h14V10" />
    <path d="M10 20v-5h4v5" />
  </IconFrame>
);

export const JoinSessionIcon = () => (
  <IconFrame>
    <rect x="3" y="6" width="13" height="12" rx="2" />
    <path d="M16 10l5-3v10l-5-3" />
  </IconFrame>
);
